import axios from "axios";
import {
  ADMIN_PERSONAL_INFO_FAIL,
  ADMIN_PERSONAL_INFO_REQUEST,
  ADMIN_PERSONAL_INFO_SUCCESS,
  GET_ADMIN_PERSONAL_INFO_FAIL,
  GET_ADMIN_PERSONAL_INFO_REQUEST,
  GET_ADMIN_PERSONAL_INFO_SUCCESS,
  TOKEN_INFO_FAIL,
  TOKEN_INFO_REQUEST,
  TOKEN_INFO_SUCCESS,
} from "../../types/admin/personalInfoTypes";
import { ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS } from "../../types/manager/settingType";
import {
  GET_USER_PERSONAL_INFO_FAIL,
  GET_USER_PERSONAL_INFO_REQUEST,
  GET_USER_PERSONAL_INFO_SUCCESS,
} from "../../types/user/personalInfoTypes";

//Personal Info
export const adminPersonalInfoAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADMIN_PERSONAL_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/personal/insert`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: ADMIN_PERSONAL_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: ADMIN_PERSONAL_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Token Info
export const tokenInfoAction = (token) => async (dispatch, getState) => {
  try {
    dispatch({
      type: TOKEN_INFO_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/auth/token/user/details`,
      { token },
      config
    );
    // console.log(data);
    dispatch({
      type: TOKEN_INFO_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: TOKEN_INFO_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Change Password
export const getAdminPersonalInfoAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USER_PERSONAL_INFO_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/personal/data`,
      config
    );
    // localStorage.setItem(
    //   "personalUserInfo",
    //   JSON.stringify(data?.data, null, " ")
    // );
    dispatch({
      type: GET_USER_PERSONAL_INFO_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: GET_USER_PERSONAL_INFO_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
